import styled from 'styled-components';
import { Button, SemanticUI } from '@iterable/deprecated_react_components';
import { PopoverContent, PopoverTrigger } from 'ui/popover';
import { pxToRem } from 'utils/convert';

export const RelativeLabelContainer = styled.div`
  text-align: left;
  white-space: nowrap;
  flex: 1 1 auto;
`;

export const DateLabelContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto;
`;

export const DateLabel = styled.div`
  display: inline-block;
  color: #717171;
  font-weight: 400;
  white-space: nowrap;
`;

export const StyledSemanticAccordion = styled(SemanticUI.Accordion)`
  &&& {
    margin: auto;
    .popup > & {
      box-shadow: none !important;
    }
    .cssDateRangePickerAccordionTitle.active.title {
      background-color: #eff0f0;
      border-top-left-radius: ${pxToRem(4)};
      border-top-right-radius: ${pxToRem(4)};
      pointer-events: none;
      cursor: default;
      display: flex;
    }
    .cssDateRangePickerAccordionFooter {
      cursor: default !important;
      text-align: right;
    }
    .cssDateRangePickerAccordionPopupCloseButton {
      min-width: ${pxToRem(100)};
    }
  }
`;

export const ButtonLabel = styled.div`
  display: flex;
  position: relative;
  > .relativeLabel {
    margin-right: ${pxToRem(20)};
  }
  > .dateLabelContainer {
    margin-right: ${pxToRem(20)};
  }
`;

export const StyledSemanticIcon = styled(SemanticUI.Icon)`
  &&& {
    position: absolute;
    right: -${pxToRem(14)};
  }
`;

export const StyledSemanticPopup = styled(SemanticUI.Popup)`
  &&& {
    padding: 0 !important;
    &.cssAccordionHeaderShown.ui.bottom:before {
      background-color: #eff0f0;
    }
    .accordionTitle {
      font-style: italic;
      justify-content: flex-end;
    }
  }
`;

export const MainContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  text-align: left;
`;

export const StyledPopoverContent = styled(PopoverContent)`
  max-width: fit-content;
  z-index: ${({ theme }) => theme.styles.zIndex.popover};
  padding: 0;
`;

export const StyledPopoverTrigger = styled(PopoverTrigger)`
  flex: 1 1 100%;
`;

export const StyledSemanticButton = styled(Button)`
  width: 100%;
`;
